var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "commonSelect" },
    [
      _vm.$isFlag
        ? _c("van-field", {
            staticStyle: { "border-radius": "0" },
            attrs: {
              readonly: "",
              clickable: "",
              name: "picker",
              label: _vm.selectionInfo.selectName,
              value: _vm.time,
              placeholder: "点击选择"
            },
            on: {
              click: function($event) {
                _vm.showDate = true
              }
            }
          })
        : _c(
            "div",
            { staticClass: "selectWebClass" },
            [
              _c("p", [_vm._v(_vm._s(_vm.selectionInfo.selectName))]),
              _c("el-date-picker", {
                attrs: {
                  type: _vm.webDateType,
                  placeholder: "请选择",
                  "value-format": "yyyy-MM",
                  placement: "bottom-start",
                  "picker-options": _vm.pickerOptions
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.time,
                  callback: function($$v) {
                    _vm.time = $$v
                  },
                  expression: "time"
                }
              })
            ],
            1
          ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showDate,
            callback: function($$v) {
              _vm.showDate = $$v
            },
            expression: "showDate"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: _vm.h5DateType,
              title: "选择年月",
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate
            },
            on: {
              cancel: function($event) {
                _vm.showDate = false
              },
              confirm: _vm.onConfirm
            },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }